{
  "editor": {
    "headingNew": "Nueva nota",
    "headingAmend": "Corregir la nota",
    "noteType": "Tipo de nota",
    "sign": "Firmar",
    "signing": "Firmando…",
    "cancel": "Cancelar",
    "close": "Cerrar",
    "nothingSaved": "No se guarda nada hasta que firme. No hay borrador: si sale de esta pantalla, el texto se pierde.",
    "amendExplanation": "La corrección será la versión {version}. La versión actual no se elimina, sino que permanece en la historia clínica.",
    "signedIrreversible": "Una nota firmada no se puede eliminar. Los errores se corrigen con una nueva versión.",
    "discardQuestion": "¿Cerrar la nota? El texto que ha escrito no se guardará.",
    "discardConfirm": "Cerrar sin guardar",
    "discardCancel": "Seguir escribiendo",
    "signedOk": "La nota está firmada y consta en la historia clínica.",
    "amendedOk": "La corrección está firmada como versión {version}. La versión anterior permanece en la historia clínica.",
    "reload": "Volver a cargar la nota",
    "language": "Idioma de la nota",
    "languageChoose": "Seleccione un idioma …"
  },
  "action": {
    "write": "Escribir una nota",
    "amend": "Corregir la nota",
    "showVersions": "Mostrar todas las versiones",
    "hideVersions": "Ocultar versiones"
  },
  "history": {
    "heading": "Versiones",
    "loading": "Leyendo versiones…",
    "failed": "No se han podido leer las versiones.",
    "notFound": "La nota no consta en la historia clínica.",
    "retry": "Intentar de nuevo",
    "count": "{count, plural, one {# versión} other {# versiones}}",
    "current": "Versión actual",
    "superseded": "Sustituida por una versión posterior"
  },
  "version": {
    "number": "Versión {version}",
    "written": "Registrada en la historia clínica {time}",
    "signedBy": "Firmada por {name}, {time}",
    "signedByWithTitle": "Firmada por {title} {name}, {time}",
    "unsigned": "Sin firmar",
    "retracted": "Marcada como retirada (por error)",
    "clock": "Reloj: {source}",
    "clockWithUncertainty": "Reloj: {source}, precisión indicada ±{seconds} s",
    "empty": "Esta versión no tiene texto."
  },
  "clock": {
    "gps": "GPS",
    "ntp": "Servidor de hora",
    "rtc": "Reloj propio del equipo",
    "manual": "Ajustado manualmente"
  },
  "field": {
    "bodyText": "Texto libre"
  },
  "fieldHint": {
    "subjective": "Lo que refiere el paciente.",
    "objective": "Hallazgos de la exploración y mediciones.",
    "assessment": "Su valoración.",
    "plan": "Actuación a seguir.",
    "bodyText": "Para lo que no encaja en los campos SOAP. Rellene los campos SOAP, el texto libre o ambos."
  },
  "refusal": {
    "empty": "La nota está vacía. Escriba en al menos un campo antes de firmar.",
    "typeMissing": "Seleccione un tipo de nota.",
    "typeInvalid": "El tipo de nota no se acepta. Seleccione uno de la lista.",
    "fieldTooLong": "{field} es demasiado largo. Acórtelo a un máximo de {maximum} caracteres.",
    "languageInvalid": "El código de idioma no se acepta. La nota no se ha registrado.",
    "versionStale": "Otra persona ha corregido la nota mientras usted escribía. Su texto sigue aquí: lea la nueva versión y escriba la corrección sobre ella.",
    "retracted": "La nota está marcada como retirada (por error) y no se puede corregir.",
    "clientMismatch": "La nota no se ha registrado debido a un error técnico. Inténtelo de nuevo.",
    "noteNotFound": "La nota ya no está disponible para corregirla.",
    "patientNotFound": "El paciente no consta en la historia clínica.",
    "unknown": "La nota no se ha registrado. Inténtelo de nuevo.",
    "unavailable": "Sin conexión con el servidor. La nota no se ha registrado: deje la ventana abierta e inténtelo de nuevo.",
    "languageMissing": "Seleccione el idioma en que está escrita la nota. La nota no se ha firmado."
  },
  "forensic": {
    "badge": "Relevante a efectos médico-legales",
    "mark": "Marcar como relevante a efectos médico-legales",
    "marking": "Marcando …",
    "withdraw": "Quitar la marca",
    "withdrawing": "Quitando …",
    "explanation": "La marca permite localizar la nota en una investigación posterior, por ejemplo por violencia o abusos. No indica nada sobre lo ocurrido.",
    "refused": "No se ha podido guardar la marca. La vista general está actualizada: inténtelo de nuevo.",
    "unavailable": "Sin conexión con el servidor. Vuelva a abrir la vista general del paciente y compruebe si la marca existe antes de intentarlo de nuevo.",
    "confirmQuestion": "¿Quitar la marca? La retirada se guarda en la historia clínica con su nombre, y la marca permanece como versión anterior.",
    "confirmWithdraw": "Sí, quitar la marca",
    "keep": "Mantener la marca"
  }
}
